module.exports = __webpack_public_path__ + "static/media/workflow.ce46f70b.svg";